import { useEffect, useRef, useState } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import { Maximize2, Minimize2 } from 'lucide-react';

// A button in the map's corner that makes the map fill the screen (and back;
// Esc too). The map's box gets .map-full (position: fixed over everything),
// so it works the same in a browser and in the app. Put inside a MapContainer.
export default function MapFullscreen() {
  const map = useMap();
  const btn = useRef(null);
  const [full, setFull] = useState(false);

  // Clicks and drags on the button aren't the map's.
  useEffect(() => {
    if (btn.current) {
      L.DomEvent.disableClickPropagation(btn.current);
      L.DomEvent.disableScrollPropagation(btn.current);
    }
  }, []);

  useEffect(() => {
    const box = map.getContainer().parentElement;
    box.classList.toggle('map-full', full);
    document.body.classList.toggle('map-full-open', full);
    // Leaflet has to measure itself again once its box changes size.
    const t = setTimeout(() => map.invalidateSize(), 60);
    if (!full) return () => clearTimeout(t);
    const esc = (e) => { if (e.key === 'Escape') setFull(false); };
    document.addEventListener('keydown', esc);
    return () => { clearTimeout(t); document.removeEventListener('keydown', esc); };
  }, [full, map]);

  useEffect(() => () => document.body.classList.remove('map-full-open'), []);

  return (
    <button ref={btn} type="button" className="map-full-btn" onClick={() => setFull(!full)} aria-label={full ? 'Close full screen map' : 'Full screen map'} title={full ? 'Close full screen (Esc)' : 'Full screen'}>
      {full ? <Minimize2 size={18} aria-hidden="true" /> : <Maximize2 size={18} aria-hidden="true" />}
    </button>
  );
}
